<div role="navigation" tabindex="0" aria-label="Global Navigation Menu" class="topnav" id="myTopnav">

  <a tabindex="0" alt="Link to view Dashboard" title="Dashboard" aria-label="Link to view Dashboard" class="btn"
    [routerLink]="['/dashboard']" (click)="CollapseMenu()">Dashboard</a>
  <ng-container *ngIf="IsAdmin">

    <a tabindex="0" class="btn" alt="Link to view Project Management" title="Project Management"
      aria-label="Link to view Project Management" [routerLink]="['/Projectdetails']" (click)="CollapseMenu()">Project
      Management</a>
  </ng-container>

  <ng-container *ngIf="IsAdmin">
    <a tabindex="0" class="btn" alt="Link to view Gross Proceeds Maintenance" title="Gross Proceeds Maintenance"
      aria-label="Link to view Gross Proceeds Maintenance
    " [routerLink]="['/GrossMaintenance']" (click)="CollapseMenu()">Gross Proceeds Maintenance</a>

  </ng-container>
  <ng-container *ngIf="IsAdmin">
    <a tabindex="0" class="btn" alt="Link to view Staff Maintenance" title="Staff Maintenance" aria-label="Link to view Staff
    Maintenance" [routerLink]="['/UserMaintenance']" (click)="CollapseMenu()">Staff Maintenance</a>

  </ng-container>

  <a tabindex="0" class="btn" alt="Link to view City of Jacksonville" title="City of Jacksonville"
    onclick="window.open('https://www.coj.net/','_blank')" style="cursor: pointer;"
    aria-label="Link to view City of Jacksonville Page" (click)="CollapseMenu()">COJ
  </a>

  <a tabindex="0" class="btn" alt="Link to view JTA Page" title="Jacksonville Transportation Authority"
    onclick="window.open('https://www.jobsforjax.net/','_blank')" style="cursor: pointer;"
    aria-label="Link to view JTA Page" (click)="CollapseMenu()">JTA
  </a>

  <a tabindex="0" class="btn" alt="Link to View Ordinance" title="View Ordinance"
    onclick="window.open('https://jaxcityc.legistar.com/LegislationDetail.aspx?ID=4922226&GUID=EDA46361-D18E-4EF2-B7EC-7D74C0AC3D46&Options=ID%7CText%7C&Search=Gas','_blank')"
    style="cursor: pointer;" aria-label="Link to view JTA Page" (click)="CollapseMenu()">View Ordinance
  </a>

  <ng-container *ngIf="IsAdmin">
    <div class="loginnav">
      <a tabindex="0" alt="User Name" aria-label="User Name" style="color:white;font-size: 13px;" title="{{ UserName }}"
        (click)="CollapseMenu()">{{ UserName }} ({{ Role }})</a>
      <a href="#" class="btn btn-info btn-lg"
        style="background-color:#f5b642; height: 26px; margin-top: 8px; padding-top: 2px; margin-right: 4px;"
        (click)="logoutUser()" tabindex="0" title="Log Out" aria-label="Link to log out" title="Log Out"
        (click)="CollapseMenu()">
        <span class="glyphicon glyphicon-log-out"></span>
        <font color="black">Logout</font>
      </a>
    </div>
  </ng-container>
  <ng-container *ngIf="!IsAdmin">
    <a [routerLink]="['/loginuser']" (click)="CollapseMenu()" class="loginnav" title="For COJ Employees: Click here to
      Login" alt="Link to view login" aria-label="For COJ Employees: Click the link here to view
      Login Page">For COJ Employees: Click here to Login</a>
  </ng-container>
  <a href="javascript:void(0);" title="Menu" aria-label="Click the icon to view menu items" class="icon"
    onclick="myFunction()">
    <i class="fa fa-bars"></i>
  </a>
</div>
